import React from "react";
import "./highroof-van.css";
import imagehighroof from "../../assets/images/HighRoof/high-roof.webp";

const HighRoofSection = () => {
  const whatsappNumber = "971544792905";

  return (
    <section className="py-5 high-roof-section">
      <div className="container-fluid container-lg">
        <div className="row about-us-container mx-auto align-items-center">

          {/* Image Column */}
          <div 
            className="col-md-6 col-lg-5 col-xl-5" 
            data-aos="fade-left" 
            data-aos-delay="300"
          >
            <img
              className="img-fluid rounded h-100 w-100"
              src={imagehighroof}
              loading="lazy"
              alt="High Roof Chiller Van Dubai | 1.5 Ton Freezer Van Rental UAE for Cold Transport"
              title="High Roof Refrigerated Van Rental in Dubai UAE"
            />
          </div>

          {/* Text Column */}
          <div
            data-aos="fade-right"
            data-aos-delay="300"
            className="col-md-6 col-lg-7 col-xl-6 mt-4 mt-md-0 d-flex flex-column justify-content-center text-center text-md-start"
          >
            <h2>
              High Roof Chiller & Freezer Van Rental in Dubai (1.5 Ton Refrigerated Vans)
            </h2>

            <p>
              Our high roof chiller and freezer vans in Dubai are designed for 
              safe, hygienic, and temperature-controlled transport of perishable goods. 
              With a 1.5-ton capacity and extra vertical space, these refrigerated vans 
              are ideal for handling bulk deliveries with proper airflow and storage organization.
            </p>

            <p>
              Equipped with advanced cooling systems and internal shelving, our high roof 
              freezer vans ensure that frozen food, dairy products, beverages, and pharmaceuticals 
              remain fresh and damage-free during transit across Dubai and the UAE.
            </p>

            <p>
              Whether you need reliable cold chain logistics for restaurants, catering businesses, 
              supermarkets, or food suppliers, our high roof refrigerated vans provide 
              efficient, secure, and cost-effective transport solutions.
            </p>

            {/* WhatsApp Button */}
            <div className="d-flex justify-content-center justify-content-md-start gap-3 mt-3">
              <a
                href={`https://wa.me/${whatsappNumber}`}
                className="btn--primary"
                aria-label="Book High Roof Chiller Van via WhatsApp Dubai"
              >
                Book via WhatsApp
              </a>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default HighRoofSection;